// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__21UN6","row":"Node_row__3G7Ud","label":"Node_label__22Yiw","footer":"Node_footer__UKDOb"};